module.exports = __webpack_public_path__ + "img/print.3dc25979.svg";